import type {
  Metafield,
  PredictiveSearchResult,
  Product,
  SearchResultItemConnection,
  SearchResultItemEdge,
} from "@shopify/hydrogen-react/storefront-api-types";
import { query } from "gql-query-builder";
import type IQueryBuilderOptions from "gql-query-builder/build/IQueryBuilderOptions";
import { APP_NAME, filterFields, pageFields, productFields } from "./fields";
import {
  dropDateMetafield,
  hiddenMetafield,
  launchesMetafield,
  launchMetafield,
  membershipMetafield,
  thumbnailImagesMetafield,
} from "./metafields/product-metafields";
import type { IProductMetafields } from "./product-gql";
import { commonCollectionProductFields, variants } from "./product-gql";

export interface IPredictiveSearchProduct extends Product {
  hidden?: Metafield;
  brandName?: Metafield;
  launches?: Metafield;
  thumbnailImages?: Metafield;
  accessible_memberships?: Metafield;
}

/**
 * 상품 검색 조회
 */
export interface IPredictiveSearchQuery {
  predictiveSearch: PredictiveSearchResult & {
    products: IPredictiveSearchProduct[];
  };
}

const predictiveSearchMetafield: Record<string, IQueryBuilderOptions[]> = {
  tune: [
    hiddenMetafield,
    launchMetafield,
    membershipMetafield,
    dropDateMetafield,
  ],
  yeseyesee: [hiddenMetafield],
  thisisneverthat: [hiddenMetafield],
  khakis: [hiddenMetafield, launchesMetafield],
  sunlove: [hiddenMetafield],
  wellbeingexpress: [hiddenMetafield, thumbnailImagesMetafield],
};

export const predictiveSearchQuery = query(
  {
    operation: "predictiveSearch",
    fields: [
      {
        products: [
          ...productFields,
          variants(40),
          ...predictiveSearchMetafield[APP_NAME],
        ],
      },
      { queries: ["text"] },
    ],
    variables: {
      query: { type: "String!" },
      limit: { type: "Int" },
      limitScope: { type: "PredictiveSearchLimitScope" },
      searchableFields: { type: "[SearchableField!]" },
      types: { type: "[PredictiveSearchType!]" },
      unavailableProducts: { type: "SearchUnavailableProductsType" },
    },
  },
  undefined,
  { operationName: "PredictiveSearch" },
);

export interface ISearchEdge extends SearchResultItemEdge {
  node: Product & IProductMetafields;
}

/**
 * 상품 검색 조회
 */
export interface ISearchQuery {
  search: SearchResultItemConnection & {
    edges: ISearchEdge[];
  };
}

export const searchQuery = query(
  {
    operation: "search",
    fields: [
      "totalCount",
      { productFilters: filterFields },
      { pageInfo: pageFields },
      {
        edges: [
          {
            node: [
              {
                operation: "Product",
                fields: commonCollectionProductFields,
                fragment: true,
              },
            ],
          },
        ],
      },
    ],
    variables: {
      query: { type: "String!" },
      first: { type: "Int" },
      productFilters: { type: "[ProductFilter!]" },
      sortKey: { type: "SearchSortKeys" },
      reverse: { type: "Boolean" },
      types: { type: "[SearchType!]" },
      prefix: { type: "SearchPrefixQueryType" },
      after: { type: "String" },
    },
  },
  undefined,
  { operationName: "Search" },
);
